module.exports = __webpack_public_path__ + "img/IMG_0857.f962556d.jpeg";